import React, { useState, useEffect } from 'react';
import {
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions
} from '@mui/material';
import { useAppContext } from '../context/AppContext';
import {formatToWords} from '../utils/formatInWords';

function Expense() {
  const { state, actions } = useAppContext();
  const [values, setValues] = useState({
    monthlyExpense: state.monthlyExpense || '',
    oneTimeYearly: state.oneTimeYearly || '',
  });

  useEffect(() => {
    setValues({
      monthlyExpense: state.monthlyExpense || '',
      oneTimeYearly: state.oneTimeYearly || '',
    });
  }, [state.monthlyExpense, state.oneTimeYearly]);
  
  const handleChange = (field) => (e) => {
    const raw = e.target.value.replace(/,/g, '');
    const value = raw === '' ? '' : parseInt(raw, 10) || 0;
  
    setValues(prev => ({ ...prev, [field]: value }));
    actions.updateFormData(field, value === '' ? 0 : value);
  };

  const formatNumber = (num) => {
    return num === '' ? '' : new Intl.NumberFormat('en-IN').format(num);
  };  

  return (
    <Box>
      <CardContent>
        <Box sx={{ mb: 2}}>
          <Typography variant='h6' sx={{mb:2, color: 'primary.main'}}>Household Expense (₹{formatToWords(state.monthlyExpense*12 + state.oneTimeYearly)})</Typography>
          <Typography variant="body1" component="h2" gutterBottom>
            Monthly spends & loan repayments (use calculator)
            <Typography variant='body2'>Add up all your regular expenses such as groceries, bills, travel and commute, rent, education, etc.</Typography>
          </Typography>
        
          <TextField
            // label="Monthly expenses"
            value={formatNumber(values.monthlyExpense)}
            onChange={handleChange('monthlyExpense')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='monthly expenses'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              endAdornment:<InputAdornment>/ month</InputAdornment>
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" component="h2" gutterBottom>
            Annual expenses
            <Typography variant='body2'>Annual insurance, vacations, luxury shopping, home furnishing, electronics, etc.</Typography>
          </Typography>

          <TextField
            // label="Yearly expense"
            value={formatNumber(values.oneTimeYearly)}
            onChange={handleChange('oneTimeYearly')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='annual expenses'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              endAdornment:<InputAdornment>/ year</InputAdornment>
            }}
          />
        </Box>
        
        {/* <Box sx={{ mt: 4 }}>
          <Typography variant="body1" component="h2" gutterBottom>
            Monthly EMI? (if any)
          </Typography>
          
          <TextField
            // label="EMI"
            value={formatNumber(values.emi)}
            onChange={handleChange('emi')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='monthly EMI'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              endAdornment:<InputAdornment>/ month</InputAdornment>
            }}
          />
        </Box> */}
        
        {/* <Box sx={{ mt: 2 }}>
          <Typography variant="body1" component="h2" gutterBottom>
            Monthly SIPs 
          </Typography>
          
          <TextField
            // label="SIP"
            value={formatNumber(values.sip)}
            onChange={handleChange('sip')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='monthly SIP'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              endAdornment:<InputAdornment>/ month</InputAdornment>
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" component="h2" gutterBottom>
            All other annual investments
          </Typography>
          
          <TextField
            // label="SIP"
            value={formatNumber(values.emi)}
            onChange={handleChange('emi')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='annual investments'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              endAdornment:<InputAdornment>/ year</InputAdornment>
            }}
          />
        </Box> */}
      </CardContent>
    </Box>
  );
}

export default Expense;
